const slideshows = document.querySelectorAll(".slideshow-wrapper");

slideshows.forEach(el => {
    let slideshow = el.querySelector(".swiper");
    let next = el.querySelector(".swiper-navigation--next");
    let prev = el.querySelector(".swiper-navigation--prev");
let swiper = new Swiper(slideshow, {
    loop: true,
    navigation: {
    nextEl: next,
    prevEl: prev
    },
  slidesPerView: 1,
    spaceBetween: 20,
    breakpoints: {
        750: {
            slidesPerView: 2,
        },
        990: {
            slidesPerView: 3,
        },
    }
});
});